/**
 * Program CTA handling
 *
 * 1. Rewired Buy Button links (data-program-cta anchors) add to cart on-domain
 *    via AJAX and open the theme's sticky cart bar, instead of navigating away.
 *    Non-JS fallback: the anchor href is an on-domain /cart/add permalink.
 * 2. GA4 events: `program_cta_click` on every program CTA click and
 *    `add_to_cart` on every successful add (mid-page CTAs, buy box, sticky bar).
 * 3. Shows/hides the mobile sticky add-to-cart bar.
 */
(function() {
  'use strict';

  var lastCtaLocation = null;

  function track(eventName, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      } else if (window.dataLayer && window.dataLayer.push) {
        var payload = { event: eventName };
        for (var key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) payload[key] = params[key];
        }
        window.dataLayer.push(payload);
      }
    } catch (error) { /* never break the buy path over analytics */ }
  }

  function storeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function fireAddToCart(item, ctaLocation) {
    var quantity = item.quantity || 1;
    track('add_to_cart', {
      currency: storeCurrency(),
      value: item.price ? (item.price * quantity) / 100 : undefined,
      items: [{
        item_id: String(item.variant_id || item.id || ''),
        item_name: item.product_title || item.title || document.title,
        price: item.price ? item.price / 100 : undefined,
        quantity: quantity
      }],
      cta_location: ctaLocation || 'buy_box'
    });
  }

  // Capture phase so this runs before the theme's page-transition link handler.
  document.addEventListener('click', function(evt) {
    if (!evt.target || !evt.target.closest) return;
    var cta = evt.target.closest('[data-program-cta]');
    if (!cta) return;

    var ctaLocation = cta.getAttribute('data-cta-location') || 'program_page';
    lastCtaLocation = ctaLocation;

    track('program_cta_click', {
      cta_location: ctaLocation,
      cta_label: (cta.textContent || '').trim().slice(0, 80),
      variant_id: cta.getAttribute('data-variant-id') || undefined,
      page_path: window.location.pathname
    });

    // Buttons submit the native product form; only rewired links are intercepted.
    if (cta.tagName !== 'A') return;

    var variantId = parseInt(cta.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    evt.preventDefault();
    evt.stopPropagation();

    var quantity = parseInt(cta.getAttribute('data-quantity'), 10) || 1;
    var fallbackHref = cta.getAttribute('href');

    function fallback() {
      // Navigate to the on-domain /cart/add permalink instead.
      window.location.href = fallbackHref;
    }

    if (!window.fetch) {
      fallback();
      return;
    }

    cta.classList.add('btn--loading');

    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    }).then(function(item) {
      cta.classList.remove('btn--loading');
      fireAddToCart(item, ctaLocation);
      if (window.jQuery) {
        // Refreshes and opens the theme's sticky cart / drawer UI.
        window.jQuery('body').trigger('added.ajaxProduct');
      } else {
        fallback();
      }
    }).catch(function() {
      cta.classList.remove('btn--loading');
      fallback();
    });
  }, true);

  // Native buy box + sticky bar adds go through the theme's AJAX product form,
  // which dispatches this event on success.
  document.addEventListener('added:ajaxProduct', function(evt) {
    var item = evt.detail && evt.detail.product;
    if (item) {
      fireAddToCart(item, lastCtaLocation);
      lastCtaLocation = null;
    }
  });

  // Mobile sticky add-to-cart bar: visible once the buy box scrolls out of view.
  // Re-queries the DOM on every check so it keeps working after the theme
  // editor (or anything else) re-renders the product section.
  var stickyAtcTicking = false;

  function updateStickyAtc() {
    stickyAtcTicking = false;

    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var watchSelector = bar.getAttribute('data-watch');
    var watched = watchSelector ? document.querySelector(watchSelector) : null;
    var show;

    if (document.body.classList.contains('body--sticky-cart-open')) {
      // The theme's sticky cart (checkout) bar has taken over the bottom edge.
      show = false;
    } else if (watched) {
      // Show once the buy box has been scrolled above the viewport.
      show = watched.getBoundingClientRect().bottom < 0;
    } else {
      show = (window.pageYOffset || document.documentElement.scrollTop) > 400;
    }

    bar.classList.toggle('sticky-atc--visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    // Lets the theme's floating thumb menu clear the bar (see fitness.css).
    document.body.classList.toggle('sticky-atc-visible', show);
  }

  function requestStickyAtcUpdate() {
    if (stickyAtcTicking) return;
    stickyAtcTicking = true;
    window.requestAnimationFrame(updateStickyAtc);
  }

  window.addEventListener('scroll', requestStickyAtcUpdate, { passive: true });
  window.addEventListener('resize', requestStickyAtcUpdate, { passive: true });
  window.addEventListener('orientationchange', requestStickyAtcUpdate);
  document.addEventListener('shopify:section:load', requestStickyAtcUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateStickyAtc);
  } else {
    updateStickyAtc();
  }
})();
